export default __webpack_public_path__ + "static/media/news-1.3e4ca00d.png";